import dalton from '../client';
import Apps from '../constants/Apps';

export interface SSOCheckRequest {
    /** List of app names -- Authorizes user for these apps assuming they have the proper pre-reqs */
    apps: string[];
    /** Misc request values -- recaptcha and what not */
    misc?: Record<string, string>;
}

export const DO_CHECK_COOKIE_ENDPOINT = '/sso/api/1/check';
export const DO_CHECK_COOKIE_METHOD = 'POST';

/**
 * Check if the user has a Federated SSO cookie (FISFG - implies they are logged in)
 *
 * If so, return an AuthToken authorizing the user defined by the TID in the Federated SSO cookie (FISFG) for
 * all the applications passed in.
 */
export default async function doCheckCookie() {
    const data: SSOCheckRequest = {
        apps: [Apps.CORE],
    };

    const resp = await dalton.request<string>({
        data,
        method: DO_CHECK_COOKIE_METHOD,
        url: DO_CHECK_COOKIE_ENDPOINT,
        withCredentials: true, // FISFG cookie
    });

    return resp.data;
}
